import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class SecurityBlocklistImportRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  titleToken = 'Blocklist import';

  beforeModel(): void {
    if (this.abilities.cannot('upload blocklist in security')) {
      void this.router.transitionTo('unauthorized');
    }
  }
}
